// Cetak/penyajian struk dari baris tata letak (strukLayout.js): jendela cetak browser & perintah ESC/POS.
import { catatCetak } from '../utils/catatCetak';
import { KOLOM_58MM, sajikanBaris } from './strukLayout';
import { svgQr } from './qrStruk';

const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

/** Dokumen HTML struk: monospace selebar kertas, baris yang sama dengan yang dikirim ke printer. */
export const htmlStruk = (baris, kolom = baris.kolom || KOLOM_58MM) => {
  const isi = sajikanBaris(baris, kolom)
    .map((b) => {
      if (b.gambar) return `<div class="logo"><img src="${esc(b.gambar)}" alt=""/></div>`;
      if (b.qr) return `<div class="qr">${svgQr(b.qr)}</div>`;
      return `<div class="b${b.tebal ? ' t' : ''}">${esc(b.teks) || '&nbsp;'}</div>`;
    })
    .join('');
  return `<!doctype html><html><head><meta charset="utf-8"><title>Struk</title><style>
    @page { size: ${kolom >= 48 ? 80 : 58}mm auto; margin: 0 }
    body { margin: 0; padding: 2mm; width: ${kolom}ch; font-family: "Courier New", monospace; font-size: 12px; line-height: 1.25 }
    .b { white-space: pre }
    .t { font-weight: 700 }
    .logo { text-align: center } .logo img { max-width: 100%; max-height: 50px; object-fit: contain }
    .qr { text-align: center } .qr svg { width: 32mm; height: 32mm }
  </style></head><body>${isi}</body></html>`;
};

/** Cetak lewat jendela cetak browser (iframe tersembunyi). */
export const cetakBrowser = (baris, kolom = baris.kolom || KOLOM_58MM) => {
  catatCetak(baris); // Log Aktivitas: pencetakan dicatat (cetak ulang struk yang sama = penting)
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.top = '-10000px';
  document.body.appendChild(iframe);
  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(htmlStruk(baris, kolom));
  doc.close();
  setTimeout(() => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    setTimeout(() => document.body.removeChild(iframe), 1000);
  }, 400);
};
